module.exports = __webpack_public_path__ + "static/media/ending-animal-penguin.d0494ce3.png";